import fetch from "@lib/fetch";
import { API } from "../../config";
import axios from "axios";

export const updateUser = async (token, user) => {
  let data = {
    first_name: user.firstName,
    last_name: user.lastName,
    email: user.email,
    phone: user.phone,
    organization_name: user.organizationName,
    bank_accounts: user.bankAccounts,
  };
  const res = await axios.post(`${API}/v1/users`, data, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  if (res.data.success) {
    return res.data;
  } else {
    alert(res.data.error);
  }
};

export const updateUserOnLocal = (data, next) => {
  let existing = localStorage.getItem("jwt");
  // If no existing data, create an array
  // Otherwise, convert the localStorage string to an array
  existing = existing ? JSON.parse(existing) : {};
  // Add new data to localStorage Array
  let updatedUserInfo = {
    _id: existing.user._id,
    firstName: data.firstName || existing.firstName,
    lastName: data.lastName || existing.lastName,
    email: data.email || existing.email,
    phone: data.phone || existing.phone,
    organizationName: data.organization.name || existing.organizationName,
    bankAccounts: data.organization.bankAccounts || existing.bankAccounts,
    cashOnDelivery: data.cashOnDelivery || existing.cashOnDelivery,
    insurances: data.insurances || existing.insurances,
    integrations: data.integrations || existing.integrations,
    role: data.role || existing.role,
    paymentStatus: data.paymentStatus || existing.paymentStatus,
    paymentDueDate: data.paymentDueDate || existing.paymentDueDate,
    couriers: data.couriers || existing.couriers,
    balance: data.balance || existing.balance,
    walletType: data.walletType || existing.walletType,
    type: data.type || existing.type,
  };

  existing.user = updatedUserInfo;

  if (typeof window !== "undefined") {
    localStorage.setItem("jwt", JSON.stringify(existing));
    next();
  }
};

export const getUser = (userId, token) => {
  return fetch(`${API}/v1/users/${userId}`, {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getUsers = (token) => {
  return fetch(`${API}/v1/users`, {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getAdminUser = (userId, token) => {
  return fetch(`${API}/v1/admin/users/${userId}`, {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getAdminUserOrders = (userId, token) => {
  return fetch(`${API}/v1/admin/users/${userId}/orders`, {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getAdminUserAddress = (userId, token) => {
  return fetch(`${API}/v1/admin/addresses/users/${userId}`, {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getAdminUserCatalog = (userId, token) => {
  return fetch(`${API}/v1/admin/catalogs/users/${userId}`, {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const submitNewPassword = (email, password) => {
  return fetch(`${API}/v1/new_password`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ email, password }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const forgotPasswordEmail = (email) => {
  return fetch(`${API}/v1/forgot_password`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ email }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getUserInfoByToken = (token) => {
  return fetch(`${API}/v1/users/forgot_password/${token}`, {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const updateUserCourier = (token, courier) => {
  return fetch(`${API}/v1/users/couriers`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ courier }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const updateUserByAdmin = (token, userId, data) => {
  return fetch(`${API}/v1/admin/users/${userId}`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const updateUserSubscriptionByAdmin = (token, userId, data) => {
  return fetch(`${API}/v1/admin/users/${userId}/subscriptions`, {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const removeUserSubscriptionByAdmin = (token, userId, data) => {
  return fetch(`${API}/v1/admin/users/${userId}/subscriptions`, {
    mode: "cors",
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};

export const getAdminUserTransactions = (userId, token) => {
  return fetch(`${API}/v1/admin/users/${userId}/transactions`, {
    mode: "cors",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.log(error);
    });
};
